import { Microphone2, MicrophoneSlash } from 'iconsax-reactjs';
import { FC, memo, useCallback, useEffect } from 'react';
import { usePermission } from '@/hooks/usePermission';
import { call } from '@/services/call';
import { selectSettingsPermissionsMicrophone } from '@/store/features/settings/selectors';
import { selectUserAudioEnabled } from '@/store/features/user/selectors';
import { toggleLocalAudioEnabled } from '@/store/features/user/slice';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { ToggleButton } from '@/ui';

const AudioToggleButton: FC = () => {
  usePermission('microphone');

  const dispatch = useAppDispatch();

  const audioEnabled = useAppSelector(selectUserAudioEnabled);
  const permission = useAppSelector(selectSettingsPermissionsMicrophone);

  const toggle = useCallback((value: boolean) => {
    call.toggleAudio(value);
    dispatch(toggleLocalAudioEnabled(value));
  }, [dispatch]);

  useEffect(() => {
    if (permission !== 'pending' && permission !== 'granted') {
      call.destroyAudio();
      toggle(false);
    }
  }, [permission, toggle]);

  const onClick = () => {
    toggle(!audioEnabled);
  };

  return (
    <ToggleButton disabled={permission !== 'granted'} onClick={onClick}>
      {audioEnabled ? <Microphone2 /> : <MicrophoneSlash />}
    </ToggleButton>
  );
};

export default memo(AudioToggleButton);
